import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ErrorComponent } from "@core/components/error/error.component";
import { DatabaseIndexNameType } from "@shared/models/common/database-index-name.model";
import { PersistentLinkingComponent } from "./search/persistent-linking/persistent-linking.component";
import { AbandonedMineRecordComponent } from "./search/records/abandonedMines/abandoned-mine-record.component";
import { AssessmentRecordComponent } from "./search/records/assessments/assessment-record.component";
import { DrillHoleRecordComponent } from "./search/records/drillHoles/drill-hole-record.component";
import { MineralInventoryRecordComponent } from "./search/records/mineralInventory/mineral-inventory-record.component";
import { PublicationRecordComponent } from "./search/records/publications/publication-record.component";
import { SearchComponent } from "./search/search.component";

const routes: Routes = [
  {
    path: "",
    component: SearchComponent,
    // children: [
    //   { path: "record", component: SearchRecordComponent }
    // ],
    data: {
      breadcrumb: "Text Search",
    },
  },
  { path: DatabaseIndexNameType.publication, component: PublicationRecordComponent,
    children: [
      {
        path: ':id',
        component: PublicationRecordComponent,
      }
    ]
  },
  { path: DatabaseIndexNameType.mineralInventory, component: MineralInventoryRecordComponent,
    children: [
      {
        path: ':id',
        component: MineralInventoryRecordComponent,
      }
    ]
  },
  { path: DatabaseIndexNameType.drillHoles, component: DrillHoleRecordComponent,
    children: [
      {
        path: ':id',
        component: DrillHoleRecordComponent,
        children: [
          {
            path: ':holeId',
            component: DrillHoleRecordComponent,
          }
        ]
      }
    ]
  },
  { path: DatabaseIndexNameType.assessment, component: AssessmentRecordComponent,
    children: [
      {
        path: ':id',
        component: AssessmentRecordComponent,
      }
    ]
  },
  { path: DatabaseIndexNameType.abandonedMines, component: AbandonedMineRecordComponent,
    children: [
      {
        path: ':id',
        component: AbandonedMineRecordComponent,
      }
    ]
  },
  { path: "persistent-linking", component: PersistentLinkingComponent },
  { path: "error", component: ErrorComponent }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: !isIframe ? "enabled" : "disabled",
      scrollPositionRestoration: 'enabled'
    }),
  ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [],
})
export class AppRoutingModule {}
